export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000',
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3
};

// Frontend URLs
export const FRONTEND_CONFIG = {
  URL: import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5173',
  LOGIN_URL: import.meta.env.VITE_LOGIN_URL || 'http://localhost:5173/login'
};

// App Configuration
export const APP_CONFIG = {
  NAME: import.meta.env.VITE_APP_NAME || 'Educational MIS',
  VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || 'Educational Management System'
};

// WhatsApp Configuration
export const WHATSAPP_CONFIG = {
  API_TOKEN: import.meta.env.VITE_WHATSAPP_API_TOKEN || '',
  USERNAME: import.meta.env.VITE_WHATSAPP_USERNAME || ''
};

// File Upload Configuration
export const FILE_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000',
  UPLOADS_PATH: '/uploads/'
};

// Export individual properties for convenience
export const API_BASE_URL = API_CONFIG.BASE_URL;
export const API_TIMEOUT = API_CONFIG.TIMEOUT;
export const API_RETRY_ATTEMPTS = API_CONFIG.RETRY_ATTEMPTS;
